import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/layout';

const lastUpdated = '25 أغسطس 2026';

const sections = [
  {
    title: 'قبول الشروط',
    body: [
      'باستخدام Class-Tech أو إنشاء حساب فيها، يوافق المستخدم على هذه الشروط وسياسة الخصوصية.',
      'إذا كان المستخدم طالبًا قاصرًا، فيجب أن يتم استخدام الخدمة بموافقة ولي الأمر أو الجهة التعليمية المسؤولة.',
      'قد تختلف صلاحيات المستخدم حسب الدور المخصص له داخل المنصة.',
    ],
  },
  {
    title: 'وصف الخدمة',
    body: [
      'Class-Tech منصة لإدارة أعمال التعليم الخاص والفصول والطلاب والحضور والواجبات والمدفوعات والتقارير.',
      'توفر المنصة مساحات منفصلة للمعلمين والطلاب وأولياء الأمور والموظفين والمديرين حسب الصلاحيات.',
      'قد تتكامل الخدمة مع مزودي اجتماعات أو دفع أو إشعارات لتقديم وظائف اختيارية أو لازمة للتشغيل.',
    ],
  },
  {
    title: 'مسؤوليات الحساب',
    body: [
      'يجب تقديم بيانات صحيحة وحديثة عند التسجيل واستخدام الحساب.',
      'المستخدم مسؤول عن سرية بيانات الدخول وعن أي نشاط يتم عبر حسابه.',
      'يجب إبلاغ الدعم فورًا عند الاشتباه في وصول غير مصرح به أو خطأ أمني.',
    ],
  },
  {
    title: 'الاستخدام المقبول',
    body: [
      'تستخدم الخدمة للأغراض التعليمية والإدارية المشروعة فقط.',
      'يحظر إساءة استخدام المنصة أو محاولة تجاوز الصلاحيات أو الوصول إلى بيانات غير مصرح بها.',
      'يحظر نشر محتوى مخالف للقانون أو مسيء أو منتهك لحقوق الآخرين أو خصوصيتهم.',
    ],
  },
  {
    title: 'المدفوعات والاشتراكات',
    body: [
      'تعرض الخطط والأسعار في صفحة الأسعار أو داخل الحساب عند توفرها.',
      'تعالج المدفوعات عبر مزودي دفع خارجيين، وقد تخضع لشروطهم وسياساتهم.',
      'قد يتم إيقاف أو تقييد بعض الميزات عند انتهاء الاشتراك أو تعذر الدفع.',
    ],
  },
  {
    title: 'شروط الاسترجاع',
    body: [
      'يمكن طلب استرجاع مبلغ الاشتراك خلال 7 أيام من تاريخ الدفع إذا لم يتم استخدام ميزات مدفوعة بشكل جوهري أو لم يبدأ تقديم الخدمة المرتبطة بالاشتراك.',
      'لا يشمل الاسترجاع الرسوم أو المصروفات التي يفرضها مزود الدفع أو البنك أو أي جهة خارجية، إلا إذا أكد مزود الدفع ردها فعليًا.',
      'لا تُقبل طلبات الاسترجاع بعد انتهاء مدة 7 أيام، أو عند وجود إساءة استخدام، أو مخالفة للشروط، أو استفادة فعلية من الخدمة المدفوعة خلال الفترة.',
      'في حال وجود خطأ في التحصيل أو دفع مكرر، يمكن طلب مراجعة المبلغ من الدعم، ويتم رد المبلغ الزائد بعد التحقق من السجلات.',
      'يجب إرسال طلب الاسترجاع عبر مركز الدعم أو البريد support@class-tech.net مع رقم الحساب، البريد المستخدم، تاريخ الدفع، وسبب الطلب.',
      'تتم مراجعة طلبات الاسترجاع خلال 5 إلى 10 أيام عمل، وقد تستغرق عودة المبلغ إلى وسيلة الدفع الأصلية مدة إضافية حسب مزود الدفع أو البنك.',
      'عند قبول الاسترجاع، قد يتم إلغاء أو تقييد الوصول إلى الميزات المدفوعة المرتبطة بالمبلغ المسترجع.',
    ],
  },
  {
    title: 'الخصوصية والبيانات',
    body: [
      'تخضع معالجة البيانات لسياسة الخصوصية المنشورة على /privacy.',
      'يجب على المستخدمين المصرح لهم التعامل مع بيانات الطلاب وأولياء الأمور بمسؤولية وسرية.',
      'تطبق Class-Tech ضوابط وصول وصلاحيات لحماية البيانات حسب الدور والسياق.',
    ],
  },
  {
    title: 'تعديل الخدمة أو الشروط',
    body: [
      'قد تطور Class-Tech الخدمة أو تعدل بعض الميزات لتحسين التشغيل أو الأمان أو الامتثال.',
      'قد يتم تحديث هذه الشروط من وقت لآخر، ويظهر تاريخ آخر تحديث في أعلى الصفحة.',
      'استمرار استخدام الخدمة بعد نشر التحديثات يعني قبول الشروط المحدثة، ما لم ينص القانون على غير ذلك.',
    ],
  },
  {
    title: 'الدعم والتواصل',
    body: [
      'توفر Class-Tech صفحة دعم عامة ونموذج تواصل لاستقبال الأسئلة والمشكلات.',
      'تختلف أوقات الاستجابة حسب نوع الطلب وأولويته والمعلومات المقدمة.',
      'للاستفسارات القانونية أو المتعلقة بالشروط يمكن استخدام البريد المنشور في نهاية الصفحة.',
    ],
  },
];

const TermsOfService: React.FC = () => {
  return (
    <PublicLayout>
      <div className='bg-secondary-50 text-secondary-900 dark:bg-secondary-950 dark:text-white'>
        <section className='bg-white py-16 dark:bg-secondary-900'>
          <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
            <h1 className='text-3xl font-bold text-secondary-950 dark:text-white md:text-5xl'>
              شروط الاستخدام
            </h1>
            <p className='mt-5 max-w-3xl text-lg leading-8 text-secondary-700 dark:text-secondary-200'>
              تحدد هذه الشروط القواعد العامة لاستخدام Class-Tech ومسؤوليات
              المستخدمين عند تشغيل الحسابات التعليمية والإدارية داخل المنصة.
            </p>
            <p className='mt-4 text-sm text-secondary-500 dark:text-secondary-400'>
              آخر تحديث: {lastUpdated}
            </p>
          </div>
        </section>

        <section className='py-12'>
          <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
            <div className='mb-8 rounded-lg border border-warning-200 bg-warning-50 p-5 text-warning-900 dark:border-yellow-700 dark:bg-yellow-950 dark:text-yellow-100'>
              يرجى قراءة هذه الشروط مع سياسة الخصوصية. هذه الصفحة تقدم شروطًا
              تشغيلية عامة ولا تعد بديلاً عن المشورة القانونية المتخصصة.
            </div>

            <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
              {sections.map(section => (
                <section
                  key={section.title}
                  className='rounded-lg border border-secondary-200 bg-white p-6 shadow-sm dark:border-secondary-800 dark:bg-secondary-900'
                >
                  <h2 className='text-xl font-bold text-secondary-950 dark:text-white'>
                    {section.title}
                  </h2>
                  <ul className='mt-4 list-disc space-y-2 pr-5 leading-8 text-secondary-700 dark:text-secondary-200'>
                    {section.body.map(item => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          </div>
        </section>

        <section className='bg-secondary-900 py-12 text-white'>
          <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
            <div className='flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between'>
              <div>
                <h2 className='text-2xl font-bold'>استفسارات حول الشروط</h2>
                <p className='mt-3 max-w-2xl text-secondary-300'>
                  للاستفسارات القانونية أو طلب توضيح حول استخدام المنصة، يمكن
                  التواصل معنا عبر البريد أو نموذج الدعم.
                </p>
              </div>
              <div className='flex flex-col gap-3 sm:flex-row'>
                <a
                  href='mailto:legal@class-tech.net'
                  className='inline-flex min-h-11 items-center justify-center rounded-lg bg-primary-600 px-5 text-sm font-semibold text-white hover:bg-primary-700'
                >
                  legal@class-tech.net
                </a>
                <Link
                  to='/support'
                  className='inline-flex min-h-11 items-center justify-center rounded-lg border border-white px-5 text-sm font-semibold text-white hover:bg-white hover:text-secondary-900'
                >
                  مركز الدعم
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PublicLayout>
  );
};

export default TermsOfService;
